module.exports = __webpack_public_path__ + "media/assets/faria_products/DPCORE-03ec6ac52aef7780d1451a2dd55443550885db0db929c41df92a8532005d4e6f.png";